<template>
    <PageComponent 
        :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
        :addButtonLabel="addButtonLabel"
        @handleAddNew="addNewSource"
        :searchFilters="searchFilters"
        :dropdownOptions="dropdownOptions"
        @handleDynamicOption="handleDynamicOption"
        @searchPage="searchLeadSources"
        @resetFilters="resetFilters"
        @removeItem="removeSource"
        @removeSelectedItems="removeSources"
        :addingRight="addingRight"
        :removingRight="removingRight"
        :rightsModule="rightsModule"
        :columns="tableColumns"
        :rows="sourceList"
        :actions="actions"
        :idField="idField"
        @handleSelectionChange="handleSelectionChange"
        @handleActionClick="handleActionClick"
        :count="depCount"
        :currentPage="currentPage"
        :result="depArrLen"
        @loadPrev="loadPrev"
        @loadNext="loadNext"
        @firstPage="firstPage"
        @lastPage="lastPage"
        :showNextBtn="showNextBtn"
        :showPreviousBtn="showPreviousBtn"
        :selectedValue="selectedValue"
        @selectSearchQuantity="selectSearchQuantity"
    />
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader"  @closeModal="closeModal">
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="saveLeadSource" @handleReset="handleReset"
        />
    </MovableModal>
</template>

<script>
import axios from "axios";
import { ref, computed, watch, onMounted, onBeforeMount } from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default{
    name: 'Lead_Sources',
    components:{
        PageComponent,MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('');
        const modal_loader = ref('none');
        const title = ref('Source Details');
        const addButtonLabel = ref('New Source');
        const addingRight = ref('Adding Lead Sources');
        const removingRight = ref('Deleting Lead Sources');
        const rightsModule = ref('CRM');
        const idField = 'lead_source_id';
        const selectedIds = ref([]);
        const depModalVisible = ref(false);
        const sourceList = ref([]);
        const depResults = ref([]);
        const depArrLen = ref(0);
        const depCount = ref(0);
        const pageCount = ref(0);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const selectedValue = ref(50);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const isEditing = computed(()=> store.state.Lead_Sources.isEditing)
        const selectedSource = computed(()=> store.state.Lead_Sources.selectedSource);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Name", key: "name", type: "text", editable: false},
            {label: "Description", key: "description", type: "text", editable: false},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Source', rightName: 'Editing Lead Sources'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Source', rightName: 'Deleting Lead Sources'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const name_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Search Name...", value: name_search}
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const formFields = ref([]);
        const updateFormFields = (source) => {
            formFields.value = [
                { type: 'text', name: 'name',label: "Name", value: source?.name || '', required: true },
                { type: 'text-area', name: 'description',label: "Description", value: source?.description || '', textarea_rows: '3', textarea_cols: '56', required: false },
            ];
        };
        watch(selectedSource, (newSource) => {
            updateFormFields(newSource);
        }, { immediate: true });
        const addNewSource = () =>{
            depModalVisible.value = true;
            handleReset();
            store.dispatch("Lead_Sources/updateState",{isEditing:false})
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const sourceID = row[idField];
                let formData = {
                    company: companyID.value,
                    lead_source: sourceID
                }
                await store.dispatch('Lead_Sources/fetchLeadSource',formData).
                then(()=>{
                    depModalVisible.value = true;
                    flex_basis.value = '1/2';
                    flex_basis_percentage.value = '50';
                })
                
            }else if(action == 'delete'){
                const sourceID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    lead_source: sourceID
                }
                await store.dispatch('Lead_Sources/deleteLeadSource',formData).
                then(()=>{
                    searchLeadSources();
                })
            }
        } 
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createLeadSource = async() =>{
            showModalLoader();
            let formData = {
                name: formFields.value[0].value,
                description: formFields.value[1].value,
                company: companyID.value
            }
            errors.value = [];
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Lead_Sources/createLeadSource', formData);
                    if(response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Lead Source created successfully!');
                        handleReset();
                    }else {
                        toast.error('An error occurred while creating the Lead Source.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Lead Source: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchLeadSources();
                }
            }

        }
        const updateLeadSource = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                name: formFields.value[0].value,
                description: formFields.value[1].value,
                company: companyID.value,
                lead_source: selectedSource.value.lead_source_id
            }
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                    toast.error('Fill In Required Fields');
            }else{
                try {
                    const response = await store.dispatch('Lead_Sources/updateLeadSource', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        toast.success("Lead Source updated successfully!");
                        handleReset();
                    } else {
                        toast.error('An error occurred while updating the Lead Source.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Lead Source: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchLeadSources();
                }
            }
        }
        const saveLeadSource = () =>{
            if(isEditing.value == true){
                updateLeadSource();
            }else{
                createLeadSource();
            }
        }
        const removeSource = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    lead_source: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Lead_Sources/deleteLeadSource',formData)
                    if(response && response.status == 200){
                        toast.success("Lead Source Removed Succesfully");
                        searchLeadSources();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Lead Source: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Lead Source") 
            }else{
                toast.error("Please Select A Lead Source To Remove")
            }
        }
        const removeSources = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    lead_source: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Lead_Sources/deleteLeadSource',formData)
                    if(response && response.status == 200){
                        toast.success("Lead Source(s) Removed Succesfully");
                        searchLeadSources();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Lead Source(s): ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select A Lead Source To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchLeadSources = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: name_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios
            .post(`api/v1/lead-sources-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                sourceList.value = response.data.results;
                store.commit('Lead_Sources/LIST_LEAD_SOURCES', sourceList.value)
                depResults.value = response.data;
                depArrLen.value = sourceList.value.length;
                depCount.value = depResults.value.count;
                pageCount.value = Math.ceil(depCount.value / selectedValue.value);
                
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchLeadSources();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchLeadSources();
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchLeadSources();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchLeadSources();
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchLeadSources(selectedValue.value);
        };
        const dropdownOptions = ref([
            {label: 'Populate Default', action: 'populate-default', icon: 'fa-magic', colorClass: 'text-yellow-600', rightName: 'Adding Lead Sources'}, 
        ]);
        const handleDynamicOption = async(option) =>{
            if(option == 'populate-default'){
                showLoader();
                let formData = {
                    company: companyID.value,
                }
                await axios.post('api/v1/autopopulate-lead-sources/',formData).
                then((response)=>{
                    if(response.data.msg == "Success"){
                        toast.success("Success!")
                        searchLeadSources();
                    }else{
                        toast.error(response.data.msg)
                    }
                })
                .catch((error)=>{
                    toast.error(error.message)
                })
                .finally(()=>{
                    hideLoader();
                })
            }
        };
        const resetFilters = () =>{
            name_search.value = "";
            currentPage.value = 1;
            searchLeadSources();
        };
        const closeModal = async() =>{
            depModalVisible.value = false;
            handleReset();
        }
        onMounted(()=>{
            searchLeadSources();
        })
        return{
            title,idField, searchLeadSources, addButtonLabel, searchFilters, resetFilters, tableColumns, sourceList,handleSelectionChange,
            currentPage,depResults, depArrLen, depCount, pageCount, showNextBtn, showPreviousBtn,modal_top, modal_left, modal_width,
            loadPrev, loadNext, firstPage, lastPage, actions, formFields, depModalVisible, addNewSource,
            displayButtons,flex_basis,flex_basis_percentage, handleActionClick, handleReset, saveLeadSource,
            showLoader, loader, hideLoader, modal_loader, showModalLoader, hideModalLoader, removeSource, removeSources,
            addingRight,removingRight,rightsModule, closeModal,selectedValue, selectSearchQuantity,dropdownOptions, handleDynamicOption
        }
    }
}
</script>